import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { HotToastService } from '@ngneat/hot-toast';
import { Router } from '@angular/router';

import { AccountService } from 'src/app/core/services/account.service';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { CreateUserAccountRequest } from 'src/app/core/dtos/dto';

@Component({
  selector: 'app-create-child-account',
  templateUrl: './create-child-account.component.html',
  styleUrls: ['./create-child-account.component.scss']
})
export class CreateChildAccountComponent implements OnInit {

  passwordPattern = '(?=.*\\d)(?=.*[a-zA-Z]).{8,128}';
  namePattern = '[\\u0000-\\u007f]+';
  emailInUseMessage: string;
  userForm: FormGroup;
  today = new Date();
  submitted: boolean;
  get f() { return this.userForm.controls; }

  constructor(
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private toastService: HotToastService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
      passwordConfirm: ['', Validators.required],
      firstName: ['', [Validators.required, Validators.pattern(this.namePattern)]],
      middleName: ['', Validators.pattern(this.namePattern)],
      lastName: ['', [Validators.required, Validators.pattern(this.namePattern)]],
      birthDate: ['', Validators.required],
      gender: ['', Validators.required]
    });
  }

  onSubmit() {
    this.submitted = true;
    Object.keys(this.userForm.controls).forEach((control: string) => {
      this.userForm.controls[control].markAsDirty();
    });
    if (this.userForm.controls.password.value !== this.userForm.controls.passwordConfirm.value) {
      this.toastService.warning('Please enter matching passwords.');
      return;
    }
    if (this.userForm.invalid) {
      this.toastService.warning('Please fill in the required fields');
      return;
    }

    const newUser: CreateUserAccountRequest = {
      birthDate: this.userForm.controls.birthDate.value,
      email: this.userForm.controls.email.value,
      firstName: this.userForm.controls.firstName.value,
      gender: this.userForm.controls.gender.value,
      lastName: this.userForm.controls.lastName.value,
      middleName: this.userForm.controls.middleName.value,
      password: this.userForm.controls.password.value,
      allowSMSNotifications: false,
      serviceTermId: null,
      smsPhoneNumber: null
    };

    if (this.f.email.valid) {
      this.createAccount(newUser);
      return;
    }
  }


  createAccount(request: CreateUserAccountRequest) {
    this.accountService.createChildUserAccount(request).subscribe(
      (result) => {
        if (result.content > 0)
        {
          this.toastService.success("Client account created successfully.");
          this.router.navigate(['account/edit-child-personal-info'], { queryParams: { userAccountId: result.content, userAccountEmail: request.email } });
        }
        else
        {
          this.toastService.warning("The provided email has been taken.");
        }
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          if (error.error.reasons) {
            const errorMessage = error.error as HttpErrorResponseMessages;
            errorMessage.reasons.forEach(reasons => {
              this.toastService.warning(reasons.errorMessage);
            });
          }
         else if (error.error.modelState.errors !== null) {
          const errors = error.error.modelState.errors as string[];
          errors.forEach(error => {
            this.toastService.warning(error);
          });
         }
        }
      });
  }
}
